export const createSmsOptInLink = (smsOptInKeyword: string, smsOptInPhoneNumber: string) =>
  `sms:${smsOptInPhoneNumber}?body=${smsOptInKeyword}`;
